import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/authentication/auth.service';
import { StorageService } from '../services/device/storage/storage.service';
import { firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AutoLoginGuard {
  constructor(
    private route: Router,
    private authSvc: AuthService,
    private storage: StorageService
  ) {}

  async canActivate(): Promise<boolean> {
    // If user explicitly logged out, don't auto-login
    const loggedOut = await this.storage.getKey('userLoggedOut');
    if (loggedOut === 'true') {
      return true;
    }

    // Wait for auth state to be initialized by checking onAuthStateChanged
    // This ensures we get the actual auth state, not just the initial null
    const user = await firstValueFrom(
      this.authSvc.onAuthStateChanged().pipe(take(1))
    );

    if (user) {
      const isClient = await this.authSvc.isUserClient(user.uid);
      const target = isClient ? '/private/tabs/landing' : '/private/home';
      await this.route.navigateByUrl(target, { replaceUrl: true });
      return false; // Cancel navigation to this route
    } else {
      return true; // Allow public access if no user
    }
  }
}
